import axios from 'axios';
import snackBarService from '@/shared/snackbar/snackbar.service';
import EventAggregator from './event-aggregator.entity';

export default class EventAggregatorService {
  searchAllAggregators(idProject: string): Promise<EventAggregator[]> {
    return axios
      .get(`/events/aggregators/${idProject}`)
      .then((response: any) => EventAggregator.ofList(response))
      .catch((err: any) => snackBarService.errorMessage(err.response.data.messages));
  }

  clearEventErrors(idProject: string): Promise<void> {
    return axios
      .delete(`/events/error/project/${idProject}/all`)
      .then((response: any) => response)
      .catch((err: any) => snackBarService.errorMessage(err.response.data.messages));
  }
}
